import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PluckingChecklistBPLReport } from './Pages/listing';

export const PluckingChecklistBPLReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PluckingChecklistBPLReport} />
    </Fragment>
)